import React, { memo } from 'react';
import ResponsiveHeader from '../../../shared/components/ResponsiveHeader';
import PropTypes from 'prop-types';

const RecentBlogPosts = memo(({
  id,
  title,
  data = []
}) => (
  <section id={id} className="auto-padding-section mb-6">
    <ResponsiveHeader className='mb-4' xs='h4' md='h3'>
      {title}
    </ResponsiveHeader>
    {
      data.map(post => (
        <div key={post.url}>
          <a
            variant="tertiary"
            href={post.url}
            target='_blank' rel="noreferrer">
            {post.title}
          </a>
        </div>
      ))
    }
  </section >
));

RecentBlogPosts.propTypes = {
  id: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  data: PropTypes.array,
};
RecentBlogPosts.defaultProps = {
  data: []
};

export default RecentBlogPosts;